class DesktopFullscreenMenu {
    constructor() {
        this.menuButton = document.querySelector('.veggie-burger__desktop')
        this.desktopMenu = document.querySelector('.fullscreen-menu')
        this.menuPrevColor = [] 
        this.leftArea = document.querySelector('.fullscreen-menu__left')
        this.rightArea = document.querySelector('.fullscreen-menu__right')
        this.rightAreaChildren = this.rightArea.children[0]
        this.menuAreaTL = gsap.timeline({ 
            paused: true
        })
        this.events()
    }

    events() {
        this.menuButton.addEventListener('click', () => this.toggleMenu()) 

        gsap.set(this.desktopMenu, { opacity: 0 })
        gsap.set(this.leftArea, { clipPath: 'polygon(0 0, 0 0, 0 100%, 0% 100%)' })   
        gsap.set(this.rightAreaChildren.children, { opacity: 0, yPercent: 10 })
        
        this.menuAreaTL.to(this.desktopMenu, {
            opacity: 1,
            duration: 0.4
        })    
        .to(this.leftArea, {
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            ease: 'power1.out',
            duration: 0.5
        })
        .to(this.rightAreaChildren.children, {
            opacity: 1,
            yPercent: 0,
            stagger: {
                each: 0.2
            },
            delay: 0.05
        })
    }

    toggleMenu() {
        if (this.desktopMenu.classList.contains('active')) {
            this.closeMenu()
        } else {
            this.openMenu()
        }
    }

    openMenu() {
        this.desktopMenu.classList.add('active')
        this.menuButton.classList.add('active')
        // Set playback to normal
        this.menuAreaTL.timeScale(1)
        this.menuAreaTL.play()
    
        this.menuPrevColor.unshift(document.body.style.getPropertyValue('--menu-color'))
            
        if (this.menuButton.classList.contains('active')) {
            document.body.style.setProperty('--menu-color', '#07074E')
            document.body.classList.add('no-scroll')
        } else {
            document.body.style.setProperty('--menu-color', this.menuPrevColor[1])
            document.body.classList.remove('no-scroll')
            menuPrevColor.length = 0
        }
    }

    closeMenu() {
        this.menuAreaTL.timeScale(2)
        this.menuAreaTL.reverse()
        this.menuAreaTL.eventCallback('onReverseComplete', () => this.reversedAnimationClasses())
    }

    reversedAnimationClasses() {
        this.desktopMenu.classList.remove('active')
        this.menuButton.classList.remove('active')
        this.menuPrevColor.unshift(document.body.style.getPropertyValue('--menu-color'))
        
        if (this.menuButton.classList.contains('active')) {
            document.body.style.setProperty('--menu-color', '#07074E')
            document.body.classList.add('no-scroll')
        } else {
            document.body.style.setProperty('--menu-color', this.menuPrevColor[1])
            document.body.classList.remove('no-scroll')
            this.menuPrevColor.length = 0
        }
    }
}

export default DesktopFullscreenMenu